import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { FaBars, FaTimes, FaPhone } from 'react-icons/fa';
import Logo from './Logo';
import './Navbar.css';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        document.title = "Adarsh Old Age Care Home Services | Trusted Elder Care";
        const metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        metaDescription.content =
            "Adarsh Old Age Care Home Services provides compassionate elder care, senior citizen support, and home healthcare services in Thane, Mumbai, and Navi Mumbai.";
        document.head.appendChild(metaDescription);

        const metaKeywords = document.createElement("meta");
        metaKeywords.name = "keywords";
        metaKeywords.content =
            "old age care home, elder care services, senior citizen care, home healthcare services, Thane, Mumbai, Navi Mumbai";
        document.head.appendChild(metaKeywords);

        return () => {
            document.head.removeChild(metaDescription);
            document.head.removeChild(metaKeywords);
        };
    }, []);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    const navItems = [
        { name: 'Home', to: 'hero' },
        { name: 'About', to: 'about' },
        { name: 'Services', to: 'services' },
        { name: 'Why Choose Us', to: 'why-choose' },
        { name: 'Reviews', to: 'reviews' },
        { name: 'Contact', to: 'contact' }
    ];

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        closeMenu();
    };

    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
            <div className="container">
                <div className="navbar-content">
                    <div className="navbar-brand" onClick={scrollToTop} style={{ cursor: 'pointer' }}>
                        <Logo width={70} height={70} />
                    </div>

                    <ul className={`navbar-menu ${isOpen ? 'active' : ''}`}>
                        {navItems.map((item, index) => (
                            <li key={index}>
                                <Link
                                    to={item.to}
                                    spy={true}
                                    smooth={true}
                                    offset={-80}
                                    duration={500}
                                    onClick={closeMenu}
                                    activeClass="active"
                                >
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        <li className="navbar-phone-mobile">
                            <a href="tel:9082033873" className="btn btn-primary">
                                <FaPhone /> 9082033873
                            </a>
                        </li>
                    </ul>

                    <div className="navbar-cta">
                        <a href="tel:9082033873" className="btn btn-primary">
                            <FaPhone /> 9082033873
                        </a>
                    </div>

                    <div className="navbar-toggle" onClick={toggleMenu}>
                        {isOpen ? <FaTimes /> : <FaBars />}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;